
import React, { ReactNode, useState, useEffect } from 'react';
import { useWindowSize } from '../hooks/useWindowSize';
import GenericModal from '@ui-components/Modal/GenericModal';

interface Props { children: ReactNode }

const ResponsiveGate: React.FC<Props> = ({ children }) => {
  const { isPhone, isTablet, isLaptop } = useWindowSize();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    //Whenever a small screen, the modal shows:
    if (isPhone || isTablet || isLaptop) {
        setShowModal(true);
      } else {
        setShowModal(false);
      }
    }, [isPhone, isTablet, isLaptop]);

  const handleClose = () => {
    setShowModal(false);
    // Persist “don’t show again” // to consider
    // localStorage.setItem('hideResponsiveWarning', '1');
  };

  return (
    <>
      <GenericModal
        isOpen={showModal}
        onClose={handleClose}
        title="Please note"
        size="sm"
        closeOnBackdropClick={false}
        blurBackdrop={true}
      >
        <p>
          Our responsive design is still in progress.  
          For the best experience, please use a desktop web view.
        </p>
      </GenericModal>
      {children}
    </>
  );
};

export default ResponsiveGate;
